var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3273 4.75H4.5084C3.91591 4.75 3.34769 4.98537 2.92873 5.40432C2.50978 5.82327 2.27441 6.39149 2.27441 6.98398V22.6219C2.27441 23.2144 2.50978 23.7826 2.92873 24.2015C3.34769 24.6205 3.91591 24.8558 4.5084 24.8558H20.1463C20.7388 24.8558 21.307 24.6205 21.7259 24.2015C22.1449 23.7826 22.3803 23.2144 22.3803 22.6219V14.8029",
    stroke: "#00648E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.704 3.07292C21.1484 2.62855 21.7511 2.37891 22.3795 2.37891C23.0079 2.37891 23.6106 2.62855 24.055 3.07292C24.4993 3.51728 24.749 4.11997 24.749 4.7484C24.749 5.37683 24.4993 5.97952 24.055 6.42389L13.4436 17.0353L8.97559 18.1523L10.0926 13.6843L20.704 3.07292Z",
    stroke: "#00648E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ea9084f2d4425d67f9c1fb70b210b934.svg";
export { ForwardRef as ReactComponent };